import { slicedToArray as _slicedToArray, extends as _extends, asyncToGenerator as _asyncToGenerator, toConsumableArray as _toConsumableArray, regenerator as _regenerator } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React, { useState, useEffect } from 'react';
import TransitionGroup from 'react-transition-group/TransitionGroup';
import CSSTransition from 'react-transition-group/CSSTransition';
import Cookies from 'js-cookie';
import { loadApiData, loadExternalData } from '../../utils/ApiUtil.js';
import { getCurrentRuleSetName } from '../../utils/UrlUtil.js';
import { SystemNotification } from '../system-notification/component.js';
var SystemNotifications = function SystemNotifications(_ref) {
  var adminifiUrl = _ref.adminifiUrl,
    _ref$animate = _ref.animate,
    animate = _ref$animate === void 0 ? true : _ref$animate,
    authToken = _ref.authToken,
    _ref$messageRenderDel = _ref.messageRenderDelay,
    messageRenderDelay = _ref$messageRenderDel === void 0 ? 250 : _ref$messageRenderDel,
    messages = _ref.messages,
    userId = _ref.userId;
  var getStorageKey = function getStorageKey(id) {
    return "".concat(id, "-closed-system-messages");
  };
  var closedMessageIds = function closedMessageIds() {
    var cookie = Cookies.get(getStorageKey(userId));
    return cookie ? JSON.parse(cookie) : [];
  };
  var _useState = useState(messages || []),
    _useState2 = _slicedToArray(_useState, 2),
    notificationMessages = _useState2[0],
    setNotificationMessages = _useState2[1];
  var _useState3 = useState(closedMessageIds()),
    _useState4 = _slicedToArray(_useState3, 2),
    closedMessages = _useState4[0],
    setClosedMessages = _useState4[1];
  useEffect(function () {
    var getUserMessages = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regenerator().m(function _callee() {
        var ruleSetName, messagesFromApi, allMessages, messagesToDisplay;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              ruleSetName = getCurrentRuleSetName();
              _context.n = 1;
              return getUserSytemNotifications(userId, adminifiUrl, authToken, ruleSetName);
            case 1:
              messagesFromApi = _context.v;
              allMessages = Array.isArray(messages) ? messages.concat(messagesFromApi) : messagesFromApi;
              messagesToDisplay = allMessages.filter(function (message) {
                return !closedMessages.includes(message.id);
              });
              if (messagesToDisplay.length) {
                if (animate) {
                  setTimeout(function () {
                    setNotificationMessages(messagesToDisplay);
                  }, messageRenderDelay);
                } else {
                  setNotificationMessages(messagesToDisplay);
                }
              }
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }));
      return function getUserMessages() {
        return _ref2.apply(this, arguments);
      };
    }();
    getUserMessages();
  }, [userId, adminifiUrl, authToken, messages]);
  var getUserSytemNotifications = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regenerator().m(function _callee2(userId, adminifiUrl, authToken, ruleSetName) {
      var url, messages;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.n) {
          case 0:
            url = "".concat(adminifiUrl, "/api/data/user_system_messages/").concat(userId, ".json").concat(ruleSetName ? "?rule_set_name=".concat(ruleSetName) : '');
            _context2.p = 1;
            if (!authToken) {
              _context2.n = 3;
              break;
            }
            _context2.n = 2;
            return loadExternalData(url, authToken);
          case 2:
            messages = _context2.v;
            _context2.n = 5;
            break;
          case 3:
            _context2.n = 4;
            return loadApiData(url);
          case 4:
            messages = _context2.v;
          case 5:
            _context2.n = 7;
            break;
          case 6:
            _context2.p = 6;
            _context2.v;
            // if the BE errors, that's ok, we just won't show any messages
            messages = [];
          case 7:
            return _context2.a(2, messages.filter(function (message) {
              var _message$view_locatio;
              return message === null || message === void 0 || (_message$view_locatio = message.view_locations) === null || _message$view_locatio === void 0 ? void 0 : _message$view_locatio.includes('login');
            }));
        }
      }, _callee2, null, [[1, 6]]);
    }));
    return function getUserSytemNotifications(_x, _x2, _x3, _x4) {
      return _ref3.apply(this, arguments);
    };
  }();
  var getDomain = function getDomain() {
    var domainArray = window.location.host.split(':')[0].split('.');
    domainArray.shift();
    return domainArray.join('.');
  };
  var onClose = function onClose(messageId) {
    var messages = notificationMessages.filter(function (message) {
      return message.id !== messageId;
    });
    setNotificationMessages(messages);
    var updatedClosedMessages = [].concat(_toConsumableArray(closedMessages), [messageId]);
    Cookies.set(getStorageKey(userId), JSON.stringify(updatedClosedMessages), {
      domain: getDomain()
    });
    setClosedMessages(updatedClosedMessages);
  };
  var transitionTimeout = animate ? 1000 : 0;
  return /*#__PURE__*/React.createElement("div", {
    className: "system-notifications inline"
  }, /*#__PURE__*/React.createElement(TransitionGroup, {
    className: "system-transition-group"
  }, notificationMessages.map(function (message) {
    return /*#__PURE__*/React.createElement(CSSTransition, {
      classNames: "notification",
      timeout: transitionTimeout,
      key: message.id
    }, /*#__PURE__*/React.createElement(SystemNotification, _extends({}, message, {
      onClose: onClose
    })));
  })));
};
SystemNotifications.displayName = "SystemNotifications";
export { SystemNotifications };